import { createSelector } from '@reduxjs/toolkit'
import _find from 'lodash/find'
import _sortBy from 'lodash/sortBy'

import { COUNTRY_CODE_SPAIN } from '../constants'

const pluckCountryId = (_, { id }) => id

const getCountries = (state) => state.countries.items || []

/**
 * @deprecated use RTKQ hooks instead
 */
export const getCountriesOrderedByName = createSelector([getCountries], (countries) => _sortBy(countries, ['name']))

/**
 * @deprecated use RTKQ hooks instead
 */
export const getCountrySpainId = createSelector([getCountries], (countries) => {
    const countrySpain = _find(countries, { countryCode3: COUNTRY_CODE_SPAIN })
    const countrySpainId = countrySpain?.id
    return countrySpainId
})

/**
 * @deprecated use RTKQ hooks instead
 */
export const getCountryNameById = createSelector(
    [getCountries, pluckCountryId],
    (countries, id) => _find(countries, { id })?.name
)
